import React from 'react';
import { makeStyles } from 'tss-react/mui';
import ScreenShareIndicator from "../../../filmstrip/components/web/ScreenShareIndicator";
import ModeratorIndicator from "../../../filmstrip/components/web/ModeratorIndicator";
import AudioMutedIndicator from "../../../filmstrip/components/web/AudioMutedIndicator";
const useStyles = makeStyles()(theme => {
    return {
        badge: {
            display: 'flex',
            gap: '4px',
            fontFamily: 'Lato SemiBold',
            fontWeight: 'normal',
            fontSize: '12px',
            lineHeight: '15px',
            background: 'rgba(33, 33, 33, 0.9)',
            borderRadius: '4px',
            color: 'rgba(255, 255, 255, 1)',
            maxWidth: '50%',
            overflow: 'hidden',
            padding: '4px 8px',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap'
        }
    };
});
/**
 * Component that displays a name badge.
 *
 * @param {Props} props - The props of the component.
 * @returns {ReactElement}
 */
const DisplayNameBadge = ({ name, showAudioIndicator, showModeratorIndicator, isScreenSharing, isVirtualScreenshareParticipant }) => {
    const { classes } = useStyles();
    return (React.createElement("div", { className: classes.badge },
        showAudioIndicator && React.createElement(AudioMutedIndicator, { tooltipPosition: 'top' }),
        showModeratorIndicator && React.createElement(ModeratorIndicator, { tooltipPosition: 'top' }),
        (isScreenSharing && isVirtualScreenshareParticipant) && React.createElement(ScreenShareIndicator, { tooltipPosition: "top" }),
        React.createElement("div", null, name)));
};
export default DisplayNameBadge;
